import { useFlow } from "../../../FlowEdit/useFlow";
import { RenderInputProps } from "../types";
import { Slider as AntSlider } from "antd";

export default function Slider({ item, moduleId }: RenderInputProps) {
  const { updateNodeValue } = useFlow();
  return (
    <AntSlider
      defaultValue={item.value as number}
      max={item.max}
      min={item.min}
      step={item.step}
      onChange={(v) => {
        updateNodeValue(moduleId, item.key, v);
      }}
      marks={item.markList}
    />
  );
}
